// Salve este arquivo como: components/vehicles/ModalCrlv.tsx (ou caminho similar)
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { CrlvDocument } from "@/types/vehicle.type";
import { Modal } from "flowbite-react";
import { useState } from "react";
import FormCrlv from "../Forms/FormCrlv";
export type CrlvFormValues = {
  year: string;
  crlv: string;
};
type Props = {
  vehicleId: string;
  pathToUpload: string;
  currentCrlvDocs: CrlvDocument[];
  onSave: (newDocs: CrlvDocument[]) => Promise<void>;
  onClose: () => void;
};

export default function ModalCrlv(props: Props) {
  const { showToast } = useToastContext();
  const [formRequestErrors, setFormRequestErrors] = useState<
    { message: string; path: string[] }[]
  >([]);

  const notifySuccess = (text: string) => showToast({ text, type: "success" });
  const notifyError = (text: string) => showToast({ text, type: "error" });

  const handleCloseModal = () => {
    props.onClose();
  };

  async function handleSaveCrlv(values: CrlvFormValues) {
    const { year, crlv } = values;

    // Lógica de verificação e substituição
    const existingDocIndex = props.currentCrlvDocs.findIndex(
      (doc) => doc.year === year
    );
    const newCrlvDocs = [...props.currentCrlvDocs];

    if (existingDocIndex !== -1) {
      // Já existe um documento para este ano
      const userConfirmed = window.confirm(
        `Já existe um CRLV para o ano ${year}. Deseja substituí-lo?`
      );

      if (userConfirmed) {
        // Substitui o documento existente
        newCrlvDocs[existingDocIndex] = { year, crlv };
      } else {
        // Usuário cancelou, não faz nada
        return { ok: false, data: null, errors: [] }; // Retorna para parar o 'isSubmitting' do formik
      }
    } else {
      // Adiciona o novo documento
      newCrlvDocs.push({ year, crlv });
    }

    // Ordena os documentos por ano (opcional, mas bom para consistência)
    newCrlvDocs.sort((a, b) => parseInt(b.year) - parseInt(a.year));

    try {
      // Chama a função de salvar principal passada por props
      await props.onSave(newCrlvDocs);

      notifySuccess(`CRLV do ano ${year} salvo com sucesso!`);
      props.onClose(); // Fecha o modal
      return { ok: true, data: newCrlvDocs, errors: [] };
    } catch (err) {
      console.log(err);
      notifyError("Erro ao tentar salvar o CRLV, tente novamente.");
      setFormRequestErrors([
        { message: (err as Error).message, path: ["form"] },
      ]);
      return {
        ok: false,
        data: null,
        errors: [{ message: (err as Error).message, path: [] }],
      };
    }
  }

  return (
    <Modal
      size={"3xl"} // Tamanho ajustado para um formulário menor
      className="relative"
      show={true}
      onClose={handleCloseModal}
    >
      <Modal.Header className="text-black">
        <div className="flex items-center justify-start gap-3">
          <span className="text-black">{`Enviar Documento CRLV`}</span>
        </div>
      </Modal.Header>
      <Modal.Body
        className="w-full relative border-gray flex flex-col dark:text-black"
        style={{
          minHeight: "300px", // Altura ajustada
        }}
      >
        <FormCrlv
          onSubmit={handleSaveCrlv}
          pathToUpload={props.pathToUpload}
          formRequestErrors={formRequestErrors}
        />
      </Modal.Body>
    </Modal>
  );
}
